import { Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import en from './i18n/en';
import es from './i18n/es';
import fr from './i18n/fr';
import kk from './i18n/kk';
import pt from './i18n/pt';
import ru from './i18n/ru';
import nl from './i18n/nl';

@Injectable()
export class LanguageLoader implements TranslateLoader {
  private readonly _defaultLanguage = 'en';
  private readonly _languages: Record<string, TranslationObject> = {
    en,
    es,
    fr,
    kk,
    nl,
    pt,
    ru,
  };

  getTranslation(lang: string): Observable<TranslationObject> {
    let dictionary: TranslationObject;
    if (lang in this._languages) {
      dictionary = this._languages[lang];
    } else {
      dictionary = this._languages[this._defaultLanguage];
    }
    return of(dictionary);
  }
}
